// extracted by mini-css-extract-plugin
export default {"addToCartControl":"D1-z","giftCard":"E1-z","btnContainer":"F1-z","cartButton":"G1-z","disabled":"H1-z"};